import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvIcon";
/**
 * Displays an icon in a consistent way, whether it is an image or a font.
 */
let LvIcon = class LvIcon extends UIComponent {
    get style() {
        return {
            "font-size": `${this.size}px`,
            "width": `${this.size}px`,
        };
    }
};
__decorate([
    Prop({ type: Number, required: false, default: 16 }),
    __metadata("design:type", Number)
], LvIcon.prototype, "size", void 0);
LvIcon = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvIcon);
export default LvIcon;
//# sourceMappingURL=script.js.map